import { render, staticRenderFns } from "./AppPortalTarget.vue?vue&type=template&id=561d1fae"
import script from "./AppPortalTarget.vue?vue&type=script&lang=js"
export * from "./AppPortalTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports